import { useTranslation } from "react-i18next";
import { getColor } from "../../../../pages/postEditor/seoAnalyzer/helper";

export const TitleAnalysis = ({ analysis }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Score Bar */}
       <div className="mt-4">
                  <span className="font-semibold mb-3">
                    {analysis.total_score}%
                    </span>
                    </div>
                  
                  <div className="w-full relative p-2 rounded-xl bg-slate-300 mb-5 mt-1">
                    <div
                      className={`bg-${getColor(
                        analysis.total_score
                      )} h-full rounded-xl absolute top-0 left-0`}
                      style={{ width: `${analysis.total_score}%` }}
                    ></div>
                  </div>

      {/* Target Keyword Included */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Target-Keyword-Included", "Target Keyword Included")}{" "}
        </p>
        <p
          className={`${
            analysis?.keyword_score == 100
              ? "text-green-500"
              : analysis?.keyword_score < 100 && analysis?.keyword_score > 0
              ? "text-yellow-400"
              : analysis?.keyword_score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.keyword_score == 100
            ? t(
                "The-target-request-fully-appears-in-the-H1-title.That’s-perfect!",
                "The target request fully appears in the H1 title. That’s perfect!"
              )
            : analysis?.keyword_score < 100 && analysis?.keyword_score > 0
            ? t(
                "The-target-request-partially-appears-in-the-H1-title.Try-to-add-the-rest!",
                "The target request partially appears in the H1 title. Try to add the rest!"
              )
            : analysis?.keyword_score == 0
            ? `${t(
                "The-target-request-does-not-appear-in-the-H1-title.Add-it!",
                "The target request does not appear in the H1 title. Add it!"
              )}`
            : `${t("Please-add-title", "Please-add-title")}`}
        </p>
      </div>

      {/* Length Check */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">{t("Length", "Length")}</p>
        <p
          className={`${
            analysis?.title_length?.score > 70
              ? "text-green-500"
              : analysis?.title_length?.score >= 35
              ? "text-yellow-400"
              : analysis?.title_length?.score >= 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.title_length?.score > 70 && (
            <>
              {` ${t(
                "The-H1-title-has-a-good-size",
                "The H1 title has a good size "
              )}
   (${analysis?.title_length.charCount} ${t("character", "character")}${
                analysis?.title_length.charCount > 1 ? "s" : ""
              } ${t("for", "for")} ${analysis?.title_length.wordCount}
    ${t("word", "word")}${analysis?.title_length.wordCount > 1 ? "s" : ""}).`}
            </>
          )}
          {analysis?.title_length?.score >= 35 &&
            analysis?.title_length?.score <= 70 && (
              <>
                {` ${t(
                  "The-H1-title-is-a-bit-too",
                  "The H1 title is a bit too"
                )}
   ${
     analysis?.title_length.charCount < 35
       ? t("short", "short")
       : t("long", "long")
   }
  ( ${analysis?.title_length.charCount} ${t("character", "character")}${
                  analysis?.title_length.charCount > 1 ? "s" : ""
                } ${t("for", "for")} ${analysis?.title_length.wordCount}
    ${t("word", "word")}${analysis?.title_length.wordCount > 1 ? "s" : ""}).`}
              </>
            )}
          {analysis?.title_length?.score >= 0 &&
            analysis?.title_length?.score < 35 && (
              <>
                {` ${t("The-H1-title-is-too", "The H1 title is too")}
                                   ${
                                     analysis?.title_length.charCount < 25
                                       ? t("short", "short")
                                       : t("long", "long")
                                   }
                                   (${analysis?.title_length.charCount} ${t(
                  "character",
                  "character"
                )}${analysis?.title_length.charCount > 1 ? "s" : ""} ${t(
                  "for",
                  "for"
                )} ${analysis?.title_length.wordCount}
                                    ${t("word", "word")}${
                  analysis?.title_length.wordCount > 1 ? "s" : ""
                }).`}
              </>
            )}
          {analysis?.title_length?.score == -1 && (
            <>{t("Please-add-title", "Please-add-title")}</>
          )}
        </p>
      </div>

      {/* Appearance */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Appearance", "Appearance")}{" "}
        </p>

        <p
          className={`${
            analysis?.appearance_count?.score == 100
              ? "text-green-500"
              : analysis?.appearance_count?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.appearance_count?.score == 100 && (
            <>
              {t(
                "There-is-only-one-H1-tag-in-your-content.That’s-perfect!",
                "There is only one H1 tag in your content. That’s perfect!"
              )}
            </>
          )}
          {analysis?.appearance_count?.score == 0 && (
            <>
              {`${t("There0-are", "There are")} ${
                analysis?.appearance_count.h1Tags
              }${t(
                "H1-tags-in-your-content.Delete-some-to-only-keep-one!",
                " H1 tags in your content. Delete some to only keep one!"
              )}`}
            </>
          )}{" "}
          {analysis?.appearance_count?.score == -1 && (
            <>{t("Please-add-title", "Please-add-title")}</>
          )}
        </p>
      </div>

      {/* Repetition */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Repetition", "Repetition")}{" "}
        </p>

        <p
          className={`${
            analysis?.duplicate_check == 100
              ? "text-green-500"
              : analysis?.duplicate_check == 50
              ? "text-yellow-400"
              : analysis?.duplicate_check == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.duplicate_check == 100
            ? t(
                "All-the-words-used-in-the-H1-title-are-different.That’s-perfect!",
                "All the words used in the H1 title are different. That’s perfect!"
              )
            : analysis?.duplicate_check == 50
            ? t(
                "Some-words-are-repeated-multiple-times-in-the-H1-title!-Change-That!",
                "Some words are repeated multiple times in the H1 title!. Change That!"
              )
            : analysis?.duplicate_check == 0
            ? t(
                "Some-words-are-repeated-multiple-times-in-the-H1-title!-That’s-not-ideal!",
                "Some words are repeated multiple times in the H1 title! That’s not ideal!"
              )
            : t("Please-add-title", "Please-add-title")}
        </p>
      </div>
    </>
  );
};
